<template>
    <div>
        <a-row type="flex" style="margin-bottom: 12px">
            <a-col  style="padding-left: 12px" flex="1 1 200px">
                <strong style="font-size: 25px">Cabang</strong>
            </a-col>
            <a-col flex="0 1 300px">
                <a-button type="primary" icon="plus" block @click="showModal('')">
                Tambah
                </a-button>
            </a-col>
        </a-row>

        <a-card type="inner" size="small" >
            <a-skeleton :loading="loading" active>
                <a-table
                    class="pcp-table"
                    :columns="columns"
                    :dataSource="items.data"
                    rowKey="hash"
                    :pagination="false"
                    bordered>

                    <div slot="name" slot-scope="record" class="text-small text-left">
                        {{ record.name }}
                    </div>

                    <div slot="code" slot-scope="record" class="text-small text-left">
                        {{ record.branch_code }}
                    </div>     

                    <div slot="description" slot-scope="record" class="text-small text-left">
                        {{ record.description }}
                    </div>   

                    <div slot="order" slot-scope="record" class="text-small text-center">
                        {{ record.order }}
                    </div>            

                    <div slot="updated_at" slot-scope="record" class="text-small text-center">
                        <template v-if="record.updated_at != null">
                            {{ moment(record.updated_at).format('DD-MM-YYYY HH:mm:ss') }}
                        </template>
                    </div>

                    <div slot="action" slot-scope="record" style="text-align: center">
                        <a-space>
                            <a-tooltip title="Edit">
                                <a-button size="small" type="primary" icon="edit" @click="showModal(record.hash)" />
                            </a-tooltip>
                        </a-space>
                    </div>
                </a-table>
            </a-skeleton>
        </a-card>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visible"
            :closable="false"
        >
            <admin-setting-branch-form
                :hash="hash"
                :bank="bank"
                @handleClose="closeModal"
            />
        </a-modal>
    </div>
</template>

<script>

const columns = [
    {
		key: 'name',
		title: 'Cabang',
        align: 'center',
		scopedSlots: {customRender: 'name'},
	}, {
		key: 'code',
		title: 'Kode',
        align: 'center',
		scopedSlots: {customRender: 'code'}
	}, {
        key: 'description',
        title: 'Deskripsi',
        align: 'center',
        scopedSlots: {customRender: 'description'},
    }, {
		key: 'order',
		title: 'Order',
        align: 'center',
		scopedSlots: {customRender: 'order'}
	}, {
        key: 'updated_at',
        title: 'Last Update',
        align: 'center',
        scopedSlots: {customRender: 'updated_at'}
    }, {
		key: 'action',
		title: 'Action',
		align: 'center',
		scopedSlots: {customRender: 'action'}
	}
]

export default {
    props: {
        bank: {
            required: true
        }
    },
    data() {
        return {
            columns,
            loading: false,
            items: {
                data: []
            },
            filters: {
                q: null,
                bank: this.bank
            },
            hash: null,
            visible: false,
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri('api.branches'), {
                    params: this.filters
                })
                .then(response => this.items = response.data.branches)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        showModal(hash) {
            this.hash = hash;
            this.visible = true;
        },
        closeModal(isRefresh) {
            this.visible = false;

            if (isRefresh == true) {
                this.getItems();
            }
        },
    },
}
</script>
